// ChartSkeleton.jsx
import React from "react";
import SkeletonBox from "./SkeletonBox";

export default function ChartSkeleton() {
  return (
    <div className="w-full h-[300px] flex flex-col justify-between p-4">
      {/* Title */}
      <SkeletonBox className="h-4 w-32 mb-4" />

      {/* Bars */}
      <div className="flex-1 flex items-end gap-2">
        {Array.from({ length: 12 }).map((_, i) => (
          <SkeletonBox
            key={i}
            className="w-6 rounded-sm"
            style={{
              height: `${20 + Math.random() * 60}%`, // random varied bar height
            }}
          />
        ))}
      </div>

      {/* X-axis labels */}
      <div className="flex justify-between mt-4">
        {Array.from({ length: 12 }).map((_, i) => (
          <SkeletonBox key={i} className="h-3 w-4" />
        ))}
      </div>
    </div>
  );
}
